// TODO: Import React module
import React from 'react';

// TODO: Import MUI module
import { Box, SpeedDial, SpeedDialAction, useMediaQuery, useTheme, } from '@mui/material';

// TODO: Import MUI icon
import { CameraIndoor, Info, MenuBook, Nature, Navigation, PhotoLibrary, } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component

const RightSideNavigation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component RightSideNavigation Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const sections = [
        {
            icon: <CameraIndoor />,
            name: Text.CampusDevelopment.BlessedBotanicals.Timelapse.Title[language],
            id: 'Timelapse'
        },
        {
            icon: <PhotoLibrary />,
            name: Text.CampusDevelopment.BlessedBotanicals.Activities.Title[language],
            id: 'Activities'
        },
        {
            icon: <Info />,
            name: Text.CampusDevelopment.BlessedBotanicals.Knowledge.Title[language],
            id: 'Knowledge'
        },
        {
            icon: <Nature />,
            name: Text.CampusDevelopment.BlessedBotanicals.Garden.Title[language],
            id: 'Garden'
        },
        {
            icon: <MenuBook />,
            name: Text.CampusDevelopment.BlessedBotanicals.EBook.Title[language],
            id: 'EBook'
        },
    ];

    // TODO: Define event
    const scrollToSection = (sectionId) => {
        const targetElement = document.getElementById(sectionId);
        const topBoxName = document.getElementById('Top_BoxName');
        const topBoxMenu = document.getElementById('Top_BoxMenu');

        if (targetElement) {
            const targetPosition = targetElement.offsetTop;
            const topBarHeight = (topBoxName ? topBoxName.offsetHeight : 0) +
                (topBoxMenu ? topBoxMenu.offsetHeight : 0);

            const scrollToPosition = targetPosition - topBarHeight;

            window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
        }
    }

    React.useEffect(() => { window.scrollTo(0, 0); }, []);

    // TODO: Return component
    return (
        <SpeedDial
            ariaLabel="Navigation"
            FabProps={{ variant: isMobile ? 'circular' : 'extended', }}
            icon={<Box sx={{ display: 'flex', gap: 1 }}>
                {<Navigation />}
                {!isMobile && Text.Common.Navigate[language]}
            </Box>}
            open={true}
            sx={{ alignItems: 'end', position: 'fixed', bottom: 16, right: 16, zIndex: 1000 }}
        >
            {sections.map((section) => (
                <SpeedDialAction
                    key={section.id}
                    FabProps={{
                        size: isMobile ? 'small' : 'large',
                        sx: { backgroundColor: 'secondary.main', '&:hover': { backgroundColor: 'secondary.light', }, },
                        variant: isMobile ? 'circular' : 'extended'
                    }}
                    icon={<Box sx={{ display: 'flex', gap: 0.5, }}>
                        {section.icon}
                        {!isMobile && section.name}
                    </Box>}
                    onClick={() => {
                        if (section.id) {
                            scrollToSection(section.id);
                        }
                    }}
                />
            ))}
        </SpeedDial>
    );
};

export default RightSideNavigation;